module.exports = __webpack_public_path__ + "static/src/content/images/processed/200/Justice-League.b47354b.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/content/images/processed/200/Justice-League.jpg
// module id = EV20
// module chunks = 0